import React from 'react';

import Card from "@mui/joy/Card";
import Chip from "@mui/joy/Chip";
import CardContent from "@mui/joy/CardContent";
import {CircularProgress, Stack} from "@mui/joy";

// components
import DeliveryDetail from "../Delivery/DeliveryDetail";
import UserSubscriberContext from "../../context/UserSubscriberContext";
import DeliveryControlledEntityModal from "../Delivery/DeliveryControlledEntityModal";
import CommonEditModal from "../Common/CommonEditModal";
import ProfileHorizontalByProps from "../Profile/ProfileHorizontalByProps";
import BaseApi from "../../utils/BaseApi";
import Typography from "@mui/joy/Typography";


class DeliveryCard extends React.Component {
    static contextType = UserSubscriberContext

    constructor(props) {
        super(props);
        this.state = {
            delivery: this.props.delivery,
        };
    }

    async componentDidMount() {
        if (this.props.delivery === undefined) {
            await this.retrieveDelivery();
        } else {
            this.setState({
                delivery: this.props.delivery,
            })
        }
    }

    setDelivery(delivery){
        this.setState({
            delivery: delivery,
        })
    }

    async retrieveDelivery() {
        const api = new BaseApi();
        let url = `delivery/${this.props.deliveryId}/`;
        let response = await api.get(url, {});
        this.setState(
            {
                delivery: response.data,
            }
        );
    }

    render() {
        if (!this.state.delivery){
            return (<CircularProgress/>)
        }
        return (
            <Card
                size={'sm'}
                variant={'plain'}
            >
                <CardContent>
                    <Stack
                        direction="row"
                        justifyContent="space-between"
                        alignItems="center"
                        spacing={2}
                    >
                        <Stack
                            direction={'row'}
                            alignItems="center"
                            spacing={2}
                            flexWrap={'nowrap'}
                        >
                            <Chip
                                size={'sm'}
                                color={'primary'}
                            >
                                {this.state.delivery.xtype_human}
                            </Chip>

                            <Stack
                                direction={'row'}
                                sx={{
                                    position: 'relative',
                                }}
                            >
                                 <Chip
                                    size={'sm'}
                                    color={'neutral'}
                                >
                                    {this.state.delivery.title}
                                </Chip>
                                {this.props.updatePermission?
                                    <CommonEditModal
                                        overlay={true}
                                        fields={
                                            [
                                                'title',
                                            ]
                                        }
                                        baseUrl={'delivery'}
                                        obj={this.state.delivery}
                                        callBack={this.setDelivery.bind(this)}
                                        flat={true}
                                    />:
                                    null
                                }
                            </Stack>

                            <Chip
                                color={this.state.delivery.states[0].stage.color}
                            >
                                {this.state.delivery.states[0].stage.title}
                            </Chip>
                            {
                                this.props.showOperator?
                                    <ProfileHorizontalByProps
                                        user={this.state.delivery.states[0].operator.user}
                                    />:
                                    null
                            }
                            {
                                this.state.delivery.completed ?
                                    <Chip
                                        sx={{mr: 2}}
                                        color={'success'}
                                    >
                                        Завершен
                                    </Chip> :
                                    <Stack
                                        direction={'row'}
                                        alignItems="center"
                                        spacing={1}
                                        flexWrap={'nowrap'}
                                    >
                                        <Chip
                                            color={this.state.delivery.states[0].delay[1] ? 'success' : 'danger'}
                                        >
                                            {this.state.delivery.states[0].delay[0]}
                                        </Chip>
                                        <Typography level={'body-sm'} sx={{mb: 1}}>из</Typography>
                                        <Chip
                                            color={'primary'}
                                        >
                                            {this.state.delivery.states[0].stage.end_delay}
                                        </Chip>
                                    </Stack>
                            }
                        </Stack>
                        <Stack
                            direction={'row'}
                        >
                            <DeliveryDetail
                                delivery={this.state.delivery}
                                callBack={this.props.callBack}
                                showOpportunity={true}
                                showAccount={true}
                                overlay={true}
                            />
                            {this.props.dcePermission > 0?
                                <DeliveryControlledEntityModal
                                    delivery={this.state.delivery}
                                />:
                                null
                            }

                        </Stack>
                    </Stack>
                </CardContent>
            </Card>
        )
    }
}

export default DeliveryCard